(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-finder-bar"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Determines all available sections on a given PDP and sets up mobile finder bar
    const sectionElements = document.querySelectorAll('[data-finder-bar-item]');
    if (!sectionElements) {
      return;
    }
    const sectionElementArray = [...sectionElements];
    if (!sectionElementArray.length) {
      return;
    }
    const sectionTitles = sectionElementArray.map(
      (element) => element.dataset.finderBarItem,
    );
    const finderBarNav = document.querySelector('[data-finder-bar-nav]');
    const productContent = document.querySelector(
      '.main-product',
    );

    if (!sectionTitles.length || !finderBarNav || !productContent) {
      return;
    }

    const finderBarNavWrapper = finderBarNav.closest(
      '.product__finder-bar_outer',
    );
    if (!finderBarNavWrapper) {
      return;
    }
    // Skip intersecting entries when a user manually navigates to a section.
    let userSelectedItem = false;
    let userSelectedTimeout;

    // Scrolls to selected item
    const goToItem = (title) => {
      const activeItem = document.querySelector(
        `[data-finder-bar-item="${title}"]`,
      );

      if (!activeItem) {
        return;
      }

      userSelectedItem = true;
      clearTimeout(userSelectedTimeout);
      userSelectedTimeout = setTimeout(() => {
        userSelectedItem = false;
      }, 1000);

      window.scrollTo({
        top:
          activeItem.offsetParent.offsetTop +
          activeItem.offsetTop -
          finderBarNav.offsetHeight,
        behavior: 'smooth',
      });
    };

    // Sets current active menu item and triggers scroll
    const setActiveItem = (title, actionType) => {
      const menuItemElements = document.querySelectorAll(
        '[data-active-finder-item]',
      );
      const menuItems = Array.from(menuItemElements);
      const activeItem = menuItems.find(
        (item) => item.dataset.finderItemTitle === title,
      );

      menuItems.forEach((item) => {
        item.setAttribute('data-active-finder-item', 'false');
      });

      activeItem.setAttribute('data-active-finder-item', 'true');
      finderBarNav.scrollTo({
        left: activeItem.offsetLeft,
        behavior: 'smooth',
      });

      if (actionType === 'click') {
        goToItem(title);
      }
    };

    // Intersection observer handler
    const handleFinderIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.target === productContent) {
          if (!entry.isIntersecting && !entry.isVisible) {
            finderBarNavWrapper.classList.remove(
              'product__finder-bar_outer--inactive',
            );
            return;
          }
          finderBarNavWrapper.classList.add(
            'product__finder-bar_outer--inactive',
          );
          return;
        }

        if (userSelectedItem) {
          // The user is scrolling directly to a section, do not update this finder bar
          // while sections intersect.
          return;
        }

        if (entry.isIntersecting) {
          const element = entry.target;
          const activeTitle = element.dataset.finderBarItem;
          setActiveItem(activeTitle, 'scroll');
        }
      });
    };

    // Set up intersection observer
    const observer = new IntersectionObserver(handleFinderIntersection, {
      root: null,
      threshold: 0.25,
    });

    // Attach observer to each section
    sectionElementArray.forEach((element) => {
      observer.observe(element);
    });
    observer.observe(productContent);

    // Build menu based on buttons, attach click handlers
    sectionTitles.forEach((title) => {
      const element = document.createElement('div');
      const elementSpan = document.createElement('span');

      element.appendChild(elementSpan);
      element.textContent = decodeURIComponent(title.replaceAll('+', ' '));
      element.setAttribute('data-finder-item-title', title);
      element.setAttribute('data-active-finder-item', 'false');
      element.onclick = () => setActiveItem(title, 'click');

      finderBarNav.appendChild(element);
    });

    // Set Details active since this is the first section above the fold.
    const detailsMenuItem = document.querySelector(
      `[data-finder-item-title="Details"]`,
    );
    detailsMenuItem.setAttribute('data-active-finder-item', 'true');
  });

  } catch(e) { console.error(e); }
})();
})();
